import NewsDetail from '../sections/news-detail/NewsDetail';
import App from '../App';

window.App = App;
window.Section = NewsDetail;


